import Vue from 'vue';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import moment from 'moment';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { DateTime } from "luxon";

export default {
  name: 'Consumable',
  mixins: [validationMixin],
  components: {
    datetime: Datetime,
    DateTime,
    SelectFromList: require('@/components/selectFromList/selectFromList.vue').default,
  },
  props: ['dataObj'],
  data: function () {
    return {
      station: {},
      savedCost: -1,
      consumable: {
        comment: '',
        cost: 0,
        dt: moment(new Date()).format(),
        id: 0,
        inventoryId: 0,
        inventoryName: '',
        quantity: 0,
        warehouse: '',
        warehouseId: 0
      },
      dt: '',
      inventoryGroupId: 0,
      inventory: { text: '', value: '' },
      inventoryGroup: { text: '', value: '' },
      warehouse: { text: '', value: '' },
      inventories: [],
      inventoryGroups: [],
      selection: [],
      preference: {},
      selectedWarehouse: { },
    }
  },
  computed: {
    selectionCount: function () {
      return this.selection.length;
    },
    warehouses: function () {
      if (this.station && this.station.value != null)
        return this.dataObj.warehouses.filter(w => w.group.id == this.station.value);
      else
        return this.dataObj.warehouses;
    }
  },
  watch: {
    selectionCount: function (value) {
      this.dataObj.selection = [];
      if (value === 0)
        return;
      this.selection.forEach(p => this.dataObj.selection.push(p.id));
    },
    dt: function (val) {
      this.dataObj.dt = moment(val).format();
    },
    inventory: function (value) {
      if (!value)
        return;

      this.dataObj.inventoryId = value.id;
      this.dataObj.inventoryName = value.name;

      //error trap - first open of the will triger this function we have a price that coming in
      if (this.savedCost > 0) {
        this.dataObj.cost = this.savedCost;
        this.savedCost = 0;
        this.calculateCost();
      }
      else
        this.dataObj.cost = value.cost;
    },
    inventoryGroup: function (value) {
      if (!value)
        return;
      
      if (value.value < 0) //filter all option
        this.inventories = this.dataObj.inventories;
      else
        this.inventories = this.dataObj.inventories.filter(p => p.groupId == parseFloat(value.value));
    },
    warehouse: function (value) {
      if (!value || !value.value)
        return;

      this.consumable.warehouse = this.dataObj.warehouses.filter(p => p.value === value.value)[0].text;
      this.consumable.warehouseId = this.dataObj.warehouses.filter(p => p.value === value.value)[0].value;
    },
  },
  created() {
    //console.log("store data", this.dataObj);
    this.init();
  },
  methods: {
    resetDropDowns(type = 'all') {
      if (type == 'all')
        this.inventory = { text: "", value: "" };

      //this.warehouse = { text: "", value: "" };
    },
    twoDecimals(value) {
      return value != null && value > 0 ? parseFloat(value).toFixed(2) : 0;
    },
    getSelectedWarehouse() {
      this.preference = JSON.parse(this.$localStorage.get('_preference'));
      let selWare = this.dataObj.warehouses.filter(p => p.value == this.preference.warehouseId);

      if (selWare && selWare.length > 0)
        this.selectedWarehouse = selWare[0];
      //else
      //  this.selectedWarehouse = { text: '', value: '' };
    },
    stationSelected(item) {
      this.station = item;
    },
    calculateCost() {
      this.consumable.total = this.consumable.quantity * this.consumable.cost;
      this.consumable.totalForDisplay = this.twoDecimals(this.consumable.quantity * this.consumable.cost);
    },
    init() {
      console.log("consumable data", this.dataObj);
      Vue.nextTick(() => {
       this.savedCost = this.dataObj.cost;
        this.consumable = this.dataObj;
        this.dt = this.dataObj.dt;
        this.inventories = this.dataObj.inventories;
        this.inventoryGroups = this.dataObj.inventoryGroups;
        this.inventoryGroup = this.dataObj.inventoryGroups.filter(p => p.selected)[0];
        if (this.consumable.inventoryId > 0) {
          this.inventory = this.dataObj.inventories.filter(p => p.id === this.consumable.inventoryId)[0];
          this.consumable.cost = this.savedCost;
        }

        this.getSelectedWarehouse();
        if (this.consumable.warehouseId > 0) {
          this.warehouse = { text: this.consumable.warehouse, value: this.consumable.warehouseId };
        }
        else {
          this.warehouse = { text: this.selectedWarehouse.text, value: this.selectedWarehouse.value, };
        }

        this.consumable.total = this.consumable.quantity * this.consumable.cost;
        this.$forceUpdate();
      });
    },
  },
  validations: {
    warehouse: {
      required
    },
    inventory: {
      required
    },
  },
}

